import { useState } from "react";
import Draggable from "react-draggable";
import Paper from "@mui/material/Paper";
import { FaCircle } from "react-icons/fa6";
import useTitanApp from "../../../hooks/useTitanApp";
import DatePicker from "react-datepicker";

function DraggablePaper(props) {
  return (
    <Draggable bounds="parent" cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  );
}

export default function AudioConsultationModal({
  setShowAudioConsultationModal,
  audioConsultationTimer,
  formattedConsultationMinutes,
  formattedConsultationSeconds,
  stopTranscription,
}) {
  const { appState } = useTitanApp();
  const { darkMode } = appState;

  const [stopAudioConsultationView, setStopAudioConsultationView] =
    useState(false);

  const [stopConsultationMinutes, setStopConsultationMinutes] = useState("");
  const [stopConsultationSeconds, setStopConsultationSeconds] = useState("");
  const [rescheduleDate, setRescheduleDate] = useState(new Date());

  const handleCancelClick = () => {
    audioConsultationTimer.reset();
    setShowAudioConsultationModal(false);
  };

  const handleStopClick = () => {
    stopTranscription();
    if (audioConsultationTimer) {
      audioConsultationTimer.pause();
      setStopAudioConsultationView(true);
      setStopConsultationMinutes(formattedConsultationMinutes);
      setStopConsultationSeconds(formattedConsultationSeconds);
    }
  };

  const handleContinueClick = () => {
    setStopAudioConsultationView(false);
    audioConsultationTimer.start();
  };

  const handleDoneClick = () => {
    stopTranscription();
    setShowAudioConsultationModal(false);
  };

  return (
    <DraggablePaper className="inpersonDialog audio-consultation-modal">
      {stopAudioConsultationView ? (
        <div
          className="inperson_dialog_wrapper ended"
          id="inperson-dialog-title"
        >
          <div className="top-bar">
            <div></div>
            <div className="patient-info">
              <div className="d-flex">
                <p>Patient Name</p>
                <FaCircle color="#D0021B" size={6} />
              </div>
            </div>
          </div>
          <div className="body">
            <div className="desc">
              <p>
                This consultation lasted {stopConsultationMinutes} minutes and{" "}
                {stopConsultationSeconds} seconds
              </p>
            </div>
            <div className="options-wrapper">
              <div className="option">
                <div className="flex">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect width="24" height="24" rx="12" fill="black" />
                    <path
                      d="M9.85714 12.7143C10.2516 12.7143 10.5714 12.3945 10.5714 12C10.5714 11.6055 10.2516 11.2857 9.85714 11.2857C9.46265 11.2857 9.14286 11.6055 9.14286 12C9.14286 12.3945 9.46265 12.7143 9.85714 12.7143Z"
                      fill="white"
                    />
                    <path
                      d="M10.5714 14.1429C10.5714 14.5373 10.2516 14.8571 9.85714 14.8571C9.46265 14.8571 9.14286 14.5373 9.14286 14.1429C9.14286 13.7484 9.46265 13.4286 9.85714 13.4286C10.2516 13.4286 10.5714 13.7484 10.5714 14.1429Z"
                      fill="white"
                    />
                    <path
                      d="M12 12.7143C12.3945 12.7143 12.7143 12.3945 12.7143 12C12.7143 11.6055 12.3945 11.2857 12 11.2857C11.6055 11.2857 11.2857 11.6055 11.2857 12C11.2857 12.3945 11.6055 12.7143 12 12.7143Z"
                      fill="white"
                    />
                    <path
                      d="M12.7143 14.1429C12.7143 14.5373 12.3945 14.8571 12 14.8571C11.6055 14.8571 11.2857 14.5373 11.2857 14.1429C11.2857 13.7484 11.6055 13.4286 12 13.4286C12.3945 13.4286 12.7143 13.7484 12.7143 14.1429Z"
                      fill="white"
                    />
                    <path
                      d="M14.1429 12.7143C14.5373 12.7143 14.8571 12.3945 14.8571 12C14.8571 11.6055 14.5373 11.2857 14.1429 11.2857C13.7484 11.2857 13.4286 11.6055 13.4286 12C13.4286 12.3945 13.7484 12.7143 14.1429 12.7143Z"
                      fill="white"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M17 8.78571C17 7.79949 16.2005 7 15.2143 7H8.78571C7.79949 7 7 7.79949 7 8.78571V15.2143C7 16.2005 7.79949 17 8.78571 17H15.2143C16.2005 17 17 16.2005 17 15.2143V8.78571ZM7.71429 9.85714H16.2857V15.2143C16.2857 15.806 15.806 16.2857 15.2143 16.2857H8.78571C8.19398 16.2857 7.71429 15.806 7.71429 15.2143V9.85714ZM8.78571 7.71429H15.2143C15.806 7.71429 16.2857 8.19398 16.2857 8.78571V9.14286H7.71429V8.78571C7.71429 8.19398 8.19398 7.71429 8.78571 7.71429Z"
                      fill="white"
                    />
                  </svg>

                  <p>Re-schedule</p>
                </div>

                <DatePicker
                  className="widgetDatePicker"
                  onChange={(date) => {
                    setRescheduleDate(date);
                  }}
                  showTimeSelect
                  selected={rescheduleDate}
                  timeFormat="HH:mm"
                  timeIntervals={15}
                  dateFormat="dd/MM/yyyy h:mm aa"
                />
              </div>
            </div>

            <div className="additional-comments">
              <p>Additional Comments</p>
              <input
                type="text"
                placeholder="Note any patient feedback or concerns"
              />
            </div>

            <div className="calling-footer">
              <button
                className="continue-session"
                onClick={handleContinueClick}
              >
                <p>Continue session</p>
              </button>
              <button className="done" onClick={handleDoneClick}>
                <p>Done</p>
              </button>
            </div>
          </div>
        </div>
      ) : (
        <div id="inperson-dialog-title">
          <div className="top-bar">
            <div className="patient-info">
              <p>{`${"Patient"}'s Consultation`}</p>
            </div>
          </div>
          <div className="body">
            <h4>
              {formattedConsultationMinutes +
                ":" +
                formattedConsultationSeconds}
            </h4>
            <div className="calling-footer">
              <button className="cancel" onClick={handleCancelClick}>
                <p>Cancel</p>
              </button>
              <button className="stop" onClick={handleStopClick}>
                <p>Stop</p>
              </button>
            </div>
          </div>
        </div>
      )}
    </DraggablePaper>
  );
}

{
  /*Stop UI */
}
